import * as mutationTypes from './mutationTypes';
import * as api from '../../api/brands';
import { getErrorMessage } from '../../helpers/functions';

const actions = {
  async fetchVettings({ commit }, { brandId, apiKey }) {
    commit(mutationTypes.FETCH_VETTINGS);
    try {
      const {
        data: {
          _embedded: { vettingRequests },
        },
      } = await api.getVettings(brandId, apiKey);
      commit(mutationTypes.DONE_FETCHING_VETTINGS, { vettings: vettingRequests });
    } catch (e) {
      commit(mutationTypes.ERROR_FETCHING_VETTINGS, { error: getErrorMessage(e) });
    }
  },

  async createVettingRequest({ commit }, vetting) {
    commit(mutationTypes.CREATE_VETTING_REQUEST);
    try {
      const { data } = await api.createVetting(vetting);
      commit(mutationTypes.DONE_CREATING_VETTING_REQUEST, { vetting: data });
    } catch (e) {
      const errorTitle = getErrorMessage(e, 'title');
      if (errorTitle === 'Conflict') {
        commit(mutationTypes.ERROR_CREATING_VETTING_REQUEST, { error: 'brands.vettingRequestConflictError' });
        return;
      }
      const error = getErrorMessage(e);
      commit(mutationTypes.ERROR_CREATING_VETTING_REQUEST, { error: error.tcr || error });
    }
  },
  removeVettingError({ commit }) {
    commit(mutationTypes.REMOVE_VETTING_ERROR);
  },
};

export default actions;
